<template lang="pug">
  div(v-if="!$vuetify.breakpoint.xs")
    div(v-if="timeZoneId")
      div.headline.font-weight-regular.text-xs-right {{ currentTime }}
      div.caption {{ timeZoneId }}
</template>

<script>
export default {
  props: ['timeZoneId'],
  data() {
    return {
      currentTime: null
    }
  },
  created() {
    if(!this.$vuetify.breakpoint.xs) {
      if(this.timeZoneId) {
        this.currentTime = this.$moment().tz(this.timeZoneId).format('LTS');
        setInterval(() => this.updateCurrentTime(), 1 * 1000);
      }
    }
  },
  methods: {
    updateCurrentTime() {
      if(this.timeZoneId) {
        this.currentTime = this.$moment().tz(this.timeZoneId).format('LTS');
      }
    },
  }
}
</script>

<style scoped>
</style>